import { render, staticRenderFns } from "./ProjectsHistoricalDataListPage.vue?vue&type=template&id=82cb64a8&scoped=true&"
import script from "./ProjectsHistoricalDataListPage.vue?vue&type=script&lang=js&"
export * from "./ProjectsHistoricalDataListPage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsHistoricalDataListPage.vue?vue&type=style&index=0&id=82cb64a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82cb64a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82cb64a8')) {
      api.createRecord('82cb64a8', component.options)
    } else {
      api.reload('82cb64a8', component.options)
    }
    module.hot.accept("./ProjectsHistoricalDataListPage.vue?vue&type=template&id=82cb64a8&scoped=true&", function () {
      api.rerender('82cb64a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/HistoricalData/ProjectsHistoricalDataListPage.vue"
export default component.exports